import { render, staticRenderFns } from "./favorite-button.vue?vue&type=template&id=c6e9a3ee"
import script from "./favorite-button.vue?vue&type=script&lang=js"
export * from "./favorite-button.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports